import { render } from "./DMonth.vue?vue&type=template&id=21788492"
import script from "./DMonth.vue?vue&type=script&lang=js"
export * from "./DMonth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__